export const maxLength = (length, msg) => {
    return (value) => (!value || value.length < length ? null : msg);
};
